module.exports = {
  footerText: "Copyright Xponex © 2021",
};
